$(document).ready(function(){
  tab_login_register();
  check_submit_register();
  
  $('body').on('click','.add_review',function(e){
    e.preventDefault();
    $(document).find('.gun_modal-body .jdgm-write-rev-link').addClass('close-form-btn');
    $(document).find('.gun_modal-body .jdgm-write-rev-link').data('aria-expanded','true');
    $(document).find('.gun_modal-body .jdgm-write-rev-link').html('Cancel review');
    $(document).find('.gun_modal-body .jdgm-form-wrapper').show();
  });
  
  // Get the modal
var modal = document.getElementById("gun_myModal");

// Get the button that opens the modal
var btn = document.getElementById("get_review_pop");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("gun_close")[0];
  
var pop_cont = document.getElementsByClassName("jdgm-write-rev-link")[0];  

// When the user clicks the button, open the modal 
if(document.getElementById("get_review_pop")){
  btn.onclick = function() {
    modal.style.display = "block";  
  }  
}

// When the user clicks on <span> (x), close the modal
if(document.getElementsByClassName("gun_close")[0]){
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
} 

$('.accordion.suggestions .main_accordion').click();

var flkty = new Flickity('.recommended_product-list');

var progressBar = document.querySelector('.progress-bar')

flkty.on( 'scroll', function( progress ) {
  progress = Math.max( 0, Math.min( 1, progress ) );
  progressBar.style.width = progress * 100 + '%';
});

$('.main_accordion.reviews').on('click', function() {
    $('.jdgm-btn.jdgm-btn--solid').click();
    $(this).parent().parent().toggleClass('active');
});

$('.main_accordion.reviews').on('click', function() {
  var resizeEvent = new Event('resize');

  window.dispatchEvent(resizeEvent);
    $('.jdgm-rev-widg .jdgm-paginate__load-more')[0].click();
});


});

function tab_login_register(){
    $(".wp-tab li button").click(function(){
       var $value = $(this).attr('data-value');
       $(".wp-tab li button").removeClass('active');
       $(this).addClass("active");
       $(".tab-description .tab").each(function(){
          var $_dataValue = $(this).attr('data-value');
          if($_dataValue === $value){
          	$(this).addClass("active");
          } else {
          	$(this).removeClass("active");
          }
       });  
    });
}
function check_submit_register(){
  var regexEmail = /^[a-zA-Z0-9][a-zA-Z0-9-+_\.]{1,30}@[a-zA-Z0-9]{1,}(\.[a-zA-Z0-9]{1,}){1,5}$/;

    $("#RegisterForm input.btn").click(function(e){
       e.preventDefault();
       $(".mess_error").hide();
       $(".mess_pass_error").hide();
       $(".mess_firstname_error").hide();
       $(".mess_lastname_error").hide();
       $(".mess_birthday_error").hide();
 
       var getEmailValue = $('.register-with-email #RegisterForm-email').val(),
           getPasswordValue = $('.register-with-email #RegisterForm-password').val(),
           getFirstName = $('.register-with-email #RegisterForm-FirstName').val(),
           getLastName = $('.register-with-email #RegisterForm-LastName').val(),
           getBirthDay = $('.register-with-email #RegisterForm-birthday').val();
        console.log(getPasswordValue.length);
    if (regexEmail.test(getEmailValue) && (getPasswordValue.length > 7) && (getFirstName != '')
    && (getLastName != '')  && (getBirthDay != '')) {
      $("form#RegisterForm").submit();
      $(".mess_error").hide();
      $(".mess_pass_error").hide();
      $(".mess_firstname_error").hide();
      $(".mess_lastname_error").hide();
      $(".mess_birthday_error").hide();
    } else{
    	if(regexEmail.test(getEmailValue) != true ){
	      $(".mess_error").text("Merci d'ajouter un format d'e-mail valide");
	      $(".mess_error").show();
	    } 
	    if ( getPasswordValue.length <= 7){
	       $(".mess_pass_error").text("Votre mot de passe doit contenir au minimum 8 caractères");
	       $(".mess_pass_error").show();
      }
      if (getFirstName == '') {
        $(".mess_firstname_error").text("Merci de remplir ce champs");
	      $(".mess_firstname_error").show();
      }

      if (getLastName == '') {
        $(".mess_lastname_error").text("Merci de remplir ce champs");
	      $(".mess_lastname_error").show();
      }

      if (getBirthDay == '' || getBirthDay == undefined ) {
        $(".mess_birthday_error").text("Merci de remplir ce champs");
	      $(".mess_birthday_error").show();
      }
    }
    });
}

const headerDropdown = document.querySelector('.header_dropdown');
if(headerDropdown) {
  
  headerDropdown.addEventListener('click', () => {
    const headerContent = document.querySelector('.header_dropdown_inner');
    headerContent.classList.toggle('active');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const plusButtons = document.querySelectorAll('.samples-plus');
  const minusButtons = document.querySelectorAll('.samples-minus');
  const samplesKitContainer = document.querySelector('.samples-kit__container');
  const maxSamples = samplesKitContainer ? parseInt(samplesKitContainer.dataset.maxLimit, 10) : 0;
  const buyButton = document.getElementById('buyButton');
  let selectedSamplesOrder = [];

  function updateTotalSamples() {
      let total = 0;
      document.querySelectorAll('.samples__input--quantity').forEach(input => {
          total += parseInt(input.value) || 0;
      });
      return total;
  }

  function updateInputDisplay() {
      document.querySelectorAll('.samples__input--quantity').forEach(input => {
          input.style.display = parseInt(input.value) > 0 ? 'inline-block' : 'none';
      });
  }

  function updateButtonStates() {
      const totalSamples = updateTotalSamples();

      document.querySelectorAll('.samples-list__item').forEach(item => {
          const input = item.querySelector('.samples__input--quantity');
          const minusButton = item.querySelector('.samples-minus');
          const plusButton = item.querySelector('.samples-plus');
          const quantity = parseInt(input.value) || 0;

          minusButton.classList.toggle('disabled', quantity === 0);
          plusButton.classList.toggle('disabled', totalSamples >= maxSamples);
      });

      if (totalSamples === maxSamples) {
          buyButton.removeAttribute('disabled');
          buyButton.classList.add('active');
          buyButton.classList.remove('inactive');
      } else {
          buyButton.setAttribute('disabled', 'disabled');
          buyButton.classList.add('inactive');
          buyButton.classList.remove('active');
      }
  }

  function updateEvolvingBloc() {
      const imagesWrapper = document.querySelectorAll('.samples-kit__evolving-bloc .samples__images');

      function clearExistingContent(imagesWrapper) {
          imagesWrapper.forEach(imgWrapper => {
              imgWrapper.classList.remove('active');
              imgWrapper.querySelector('.samples-list__item__title').textContent = '';
          });
      }

      function addSelectedSamples(imagesWrapper) {
          selectedSamplesOrder.forEach((sample, index) => {
              if (index < maxSamples) {
                  const imgWrapper = imagesWrapper[index];
                  if (imgWrapper) {
                      imgWrapper.classList.add('active');
                      imgWrapper.querySelector('.samples-list__item__title').textContent = sample.title;
                  }
              }
          });
      }

      clearExistingContent(imagesWrapper);
      addSelectedSamples(imagesWrapper);

      const totalSamplesText = `(${updateTotalSamples()}/${maxSamples})`;
      document.querySelector('.samples-kit__evolving-bloc .samples-kit__evolving-bloc_title .max_quantity').textContent = totalSamplesText;
  }

  function updateSampleOrder(id, title, quantity) {
      const existingIndex = selectedSamplesOrder.findIndex(sample => sample.id === id);
      if (quantity < selectedSamplesOrder.filter(sample => sample.id === id).length) {
          selectedSamplesOrder.splice(existingIndex, 1);
      } else {
          selectedSamplesOrder.push({ id, title });
      }

      for (let i = 1; i <= maxSamples; i++) {
          const hiddenInput = document.getElementById(`sample-input-${i}`);
          if (i <= selectedSamplesOrder.length) {
              hiddenInput.value = `${selectedSamplesOrder[i - 1].title}`;
          } else {
              hiddenInput.value = '';
          }
      }
  }

  function openAccordionIfNeeded() {
      const sampleAccordion = document.querySelector('.samples-kit__evolving-bloc .sample_accordion');
      if (sampleAccordion && !sampleAccordion.classList.contains('active')) {
          sampleAccordion.click();
      }
  }

  function closeAccordionIfNeeded() {
      const sampleAccordion = document.querySelector('.samples-kit__evolving-bloc .sample_accordion');
      if (sampleAccordion && sampleAccordion.classList.contains('active')) {
          sampleAccordion.click();
      }
  }

  plusButtons.forEach(button => {
      button.addEventListener('click', function () {
          const item = this.closest('.samples-list__item');
          const input = item.querySelector('.samples__input--quantity');
          const currentValue = parseInt(input.value) || 0;
          const id = item.dataset.id;
          const title = item.dataset.title;

          if (updateTotalSamples() < maxSamples) {
              const newValue = currentValue + 1;
              input.value = newValue;
              updateSampleOrder(id, title, newValue);
              updateInputDisplay();
              updateEvolvingBloc();
              updateButtonStates();
              openAccordionIfNeeded();
          }
      });
  });

  minusButtons.forEach(button => {
      button.addEventListener('click', function () {
          const item = this.closest('.samples-list__item');
          const input = item.querySelector('.samples__input--quantity');
          const currentValue = parseInt(input.value) || 0;
          const id = item.dataset.id;
          const title = item.dataset.title;

          if (currentValue > 0) {
              const newValue = currentValue - 1;
              input.value = newValue;
              updateSampleOrder(id, title, newValue);
              updateInputDisplay();
              updateEvolvingBloc();
              updateButtonStates();
          } 
          
          if (updateTotalSamples() === 0) {
              closeAccordionIfNeeded();
          }
      });
  });

  // Initialiser les autres parties
  updateInputDisplay();
  updateEvolvingBloc();
  updateButtonStates();
});

class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
  
        this.config = {
            moveTime: parseFloat(this.dataset.speed), // Durée en secondes
            space: 100, // 100px
        };
  
        this.promotion = this.querySelector('.promotion');
    
        this.init();
    }
  
    init() {
        if (this.childElementCount === 1) {     
            this.promotion.classList.add('promotion--animated');
    
            for (let index = 0; index < 10; index++) {
                this.clone = this.promotion.cloneNode(true);
                this.clone.setAttribute('aria-hidden', true);
                this.appendChild(this.clone);
        
                const imageWrapper = this.clone.querySelector('.media-wrapper');
                if (imageWrapper) {
                    imageWrapper.classList.remove('loading');
                }
            }
    
            const animationTimeFrame = this.config.moveTime;
    
            this.style.setProperty('--duration', `${animationTimeFrame}s`);
    
            // pause when out of view
            const observer = new IntersectionObserver((entries, _observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.scrollingPlay();
                    } else {
                        this.scrollingPause();
                    }
                });
            }, {rootMargin: '0px 0px 50px 0px'});
    
            observer.observe(this);
        } else {
        }
    }
  
    scrollingPlay() {
        this.classList.remove('scrolling-promotion--paused');
    }
  
    scrollingPause() {
        this.classList.add('scrolling-promotion--paused');
    }
}
customElements.define('scrolling-promotion', ScrollingPromotion);